import { GraphQLFetchPolicy } from '@getaccept/lib-shared/src/graphql/graphql-fetch-policy';
import { apolloClientInternal } from '@getaccept/lib-shared/src/internal/apollo-client-internal';
import { SubscriptionQueries } from '../graphql/subscription.queries';
import type { SubscriptionEstimate } from '../types/subscription-estimate';
import type { UpdateSubscriptionArgs } from '../types/subscription-args';
import { SubscriptionMutations } from '../graphql/subscription.mutations';
import type { Subscription } from '../types/subscription';

export default class SubscriptionService {
  static async estimateExistingSubscription(
    payload: UpdateSubscriptionArgs
  ): Promise<SubscriptionEstimate> {
    const {
      data: { estimateExistingSubscription },
    } = await apolloClientInternal.query({
      query: SubscriptionQueries.estimateExistingSubscription,
      variables: { ...payload },
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });

    return estimateExistingSubscription;
  }

  static async updateSubscription(payload: UpdateSubscriptionArgs): Promise<boolean> {
    const { data } = await apolloClientInternal.mutate({
      mutation: SubscriptionMutations.updateSubscription,
      variables: {
        ...payload,
      },
    });

    return data;
  }

  static async load(): Promise<Subscription> {
    const {
      data: { subscription },
    } = await apolloClientInternal.query({
      query: SubscriptionQueries.load,
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });

    return subscription;
  }
}
